module.exports = __webpack_public_path__ + "img/wode1.f71c78dc.png";